import { Route, Routes } from 'react-router-dom';
import { ChainalysisLookup as ChainalysisLookupView } from './components/ChainalysisLookup';

export const ChainalysisLookup = () => {
  return (
    <Routes>
      <Route path="/" element={<ChainalysisLookupView />} />
    </Routes>
  );
};
